import React, { useEffect, useContext, useState } from 'react'
import { AcademyContext } from '../../../../Context/AcademyContext/AcademyContext'
import { VerifiedCon } from './styles'
import { Head3 } from '../../../../Components/Typography/Text.styles'
import { VerifiedClub } from './VerifiedClub'
import { AcademyVerified } from '../../../../Api'

export const VerifiedSection: React.FC = () => {
  const { verifiedLoading, verifiedClubs } = useContext(AcademyContext)!
  const [clubs, setClubs] = useState<AcademyVerified[]>([])

  useEffect(() => {
    if(verifiedLoading) return
    setClubs(verifiedClubs)
  }, [verifiedClubs, verifiedLoading])

  return (
    <VerifiedCon>
      {clubs.length > 0 &&
        clubs.map((club) => <VerifiedClub key={club.clubId} club={club} />)}
      {clubs.length < 1 && (
        <Head3>Verified clubs have not been announced yet.</Head3>
      )}
    </VerifiedCon>
  )
}
